<!-- Menu header -->
<div class="navbar-header">
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item me-auto">
            <!-- App Branding -->
            <a class="navbar-brand" [routerLink]="['/']">
                <span class="brand-logo">
                    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" />
                </span>
                <!-- <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2> -->
                <span class="app-simplesign-logo">
                    <img class="app-simplesign-logo-blue" src="/assets/images/logo/blueVariantLogoSimplesignSvg.svg" alt="brand-logo" />
                    <img class="app-simplesign-logo-white" src="/assets/images/logo/blueVariantLogoSimplesignSvgBlue.svg" alt="brand-logo" />
                </span>
            </a>
        </li>

        <!-- Menu Toggler -->
        <!-- <li class="nav-item nav-toggle hidden">
            <a class="nav-link modern-nav-toggle d-none d-xl-block pe-0" (click)="toggleSidebarCollapsible()">
                <i [ngClass]="isCollapsed === true ? 'icon-circle' : 'icon-disc'" class="toggle-icon feather font-medium-4 collapse-toggle-icon text-primary"></i>
            </a>
            <a class="nav-link modern-nav-toggle d-block d-xl-none pe-0" (click)="toggleSidebar()">
                <i data-feather="x" class="font-medium-4 text-primary toggle-icon"></i>
            </a>
        </li> -->
    </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled }"></div>

<!-- Main menu -->
<div class="main-menu-content">
    <ul class="navigation navigation-main pb-0" layout="vertical" core-menu></ul>

    <!-- <ul class="navigation navigation-main workspace-section">
        <li class="navigation-header">
           <span class="navigation-section-text">Workspace</span>
           <i data-feather="plus" class="text-primary toggle-icon cursor-pointer" size="14"></i>
        </li>
        <li class="">
           <a class="d-flex align-items-center" ng-reflect-router-link="charts-and-maps/google-maps" ng-reflect-target="_self" href="#/charts-and-maps/google-maps" target="_self">
                <i data-feather="layers" class="font-medium-4 text-primary toggle-icon" size="14"></i>
                <span class="menu-title text-truncate">All Documents</span>
           </a>
        </li>
        <li class="">
           <a class="d-flex align-items-center" ng-reflect-router-link="charts-and-maps/google-maps" ng-reflect-target="_self" href="#/charts-and-maps/google-maps" target="_self">
                <i data-feather="layers" class="font-medium-4 text-primary toggle-icon" size="14"></i>
                <span class="menu-title text-truncate">Marketing</span>
           </a>
        </li>
        <li class="">
           <a class="d-flex align-items-center" ng-reflect-router-link="charts-and-maps/google-maps" ng-reflect-target="_self" href="#/charts-and-maps/google-maps" target="_self">
                <i data-feather="layers" class="font-medium-4 text-primary toggle-icon" size="14"></i>
                <span class="menu-title text-truncate">Product Development</span>
           </a>
        </li>
     </ul> -->
</div>
<!--/ Main menu -->
